import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeRoutingModule } from './home-routing.module';
import { LandingComponent } from './landing/landing.component';
import { OwlModule } from 'ngx-owl-carousel';
import { LayoutComponent } from './layout/layout.component';
import { SharedModule } from './../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PdfViewerModule } from 'ng2-pdf-viewer';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import { from } from 'rxjs';

import { CmsPageComponent } from './cms-page/cms-page.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ElementsComponent } from './elements/elements.component';
import { AfterLoginLayoutComponent } from './after-login-layout/after-login-layout.component';
import { ForgetPasswordResetComponent } from './forget-password-reset/forget-password-reset.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SearchComponent } from './search/search.component';
import { EdtechComponent } from './edtech/edtech.component';
import { CategoryBookListComponent } from './category-book-list/category-book-list.component';
import { ReciveAnnouncementComponent } from './recive-announcement/recive-announcement.component';
import { ViewMoreBookComponent } from './view-more-book/view-more-book.component';
import { ReadBookComponent } from './read-book/read-book.component';

// Configs  for social login
export function getAuthServiceConfigs() {
	const config = new AuthServiceConfig(
		[
			{
				id: GoogleLoginProvider.PROVIDER_ID,
        // provider: new GoogleLoginProvider('489777325316-5gine3o2t9fp5crschngc88559o9e6a6.apps.googleusercontent.com')
        // provider: new GoogleLoginProvider('560756482976-4rvglbb5vhmq04jtiv5h5etks88m0nl7.apps.googleusercontent.com')
           provider: new GoogleLoginProvider('136352665748-h9kfgfkibepl8ohn6npk946msugmsrhv.apps.googleusercontent.com')
			},
		]);
	return config;
}

@NgModule({
  declarations: [
    LandingComponent,
    LayoutComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    CmsPageComponent,
    ContactUsComponent,
    ElementsComponent,
    AfterLoginLayoutComponent,
    ForgetPasswordResetComponent,
    PageNotFoundComponent,
    SearchComponent,
    EdtechComponent,
    CategoryBookListComponent,
    ReciveAnnouncementComponent,
    ViewMoreBookComponent,
    ReadBookComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HomeRoutingModule,
    OwlModule,
    SharedModule,
    NgbModule,
    SocialLoginModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
  PdfViewerModule
  ],
  providers:[
    {
			provide: AuthServiceConfig,
			useFactory: getAuthServiceConfigs
    },
  ]
})


export class HomeModule { }
